import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const driverMonitoringPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Inicio', onClick: () => navigate('/') },
  { label: 'Sistema de envíos', onClick: () => navigate('/business') },
  {
    label: 'Monitoreo de conductores',
    onClick: () => navigate('/business/driver-monitoring'),
  },
];

export const childrenDriverMonitoringPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [...driverMonitoringPageBreadcrumbs(navigate)];
